import React, { useState, useEffect} from "react";
import { Modal, Button } from "react-bootstrap";
import { BsArrowRight, BsCalendarMinusFill } from "react-icons/bs";
import FormRequest from "../../../pages/WorkFlow/Requests/Form/FormRequest"
import style from "../Modal.module.scss";
import "../../../pages/DataCollection/style.css";

const MODAL_REQUEST = ({ refreshRequest, ...modalProps }) => {
    const pushRequest = () => {
        refreshRequest();
    }
    return (
        <Modal
            {...modalProps}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={style.todisModalContainer}
            dialogClassName={style.sizeModal70}
        >
            <Modal.Header closeButton className={style.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter" className={style.modalTitle}>
                    <BsCalendarMinusFill className="me-3" />Create New Item to Monitor
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormRequest pushRequest={pushRequest} {...modalProps} />
            </Modal.Body>
        </Modal>
    )
}

export { MODAL_REQUEST };